import { FC, ReactElement } from 'react';

import { Box, SxProps, Theme, Typography } from '@mui/material';

interface TextDisplay {
    label: string;
    value: string | number | ReactElement;
    labelTypographyStyles?: SxProps<Theme>;
    valueTypographyStyles?: SxProps<Theme>;
}

export const TextDisplay: FC<TextDisplay> = ({
    label,
    value,
    labelTypographyStyles,
    valueTypographyStyles,
}) => {
    const optionalValueTypes = ['string', 'number'];
    return (
        <Box flex={0.5} padding="8px">
            <Typography
                fontSize="14px"
                color="#1D1D1B"
                fontWeight="600"
                lineHeight="21px"
                marginBottom="24px"
                sx={labelTypographyStyles}
            >
                {label}
            </Typography>
            {optionalValueTypes.includes(typeof value) ? (
                <Typography
                    fontSize="20px"
                    color="#8E8E8D"
                    fontWeight="400"
                    lineHeight="30px"
                    sx={valueTypographyStyles}
                >
                    {typeof value === 'string' ? value.replace(/_/g, ' ') : value}
                </Typography>
            ) : (
                value
            )}
        </Box>
    );
};
